export default __webpack_public_path__ + "static/media/network.283d58a0.jpeg";